import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=3b41a5f8&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=3b41a5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41a5f8",
  null
  
)

export default component.exports